// App.jsx
import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from './components/Header';
import { ThemeProvider } from '@mui/material/styles';
import theme from './theme';
import CssBaseline from '@mui/material/CssBaseline';
import { Box, Container } from '@mui/material';

const App = () => {
    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <Box
                sx={{
                    minHeight: '100vh',
                    color: 'text.primary',
                }}
            >
                <Header />
                <Box component="main" sx={{ py: { xs: 3, md: 5 } }}>
                    <Container maxWidth="xl">
                        <Outlet />
                    </Container>
                </Box>
            </Box>
        </ThemeProvider>
    );
};

export default App;
